import type { TFunction } from 'i18next';

/**
 * Shared "Filter by" dropdown option lists reused across every Model
 * table (Command Center's Model Registry/Configured Models, and the
 * org-facing Models landing page). LLM/Embedding is a genuine fixed
 * 2-value enum (ModelRegistryType) and Yes/No is a generic boolean-filter
 * label pair — neither varies per table, so each lived as a copy-pasted
 * local constant before this was extracted.
 */
export interface FilterOptionItem {
  value: string;
  label: string;
}

/**
 * Single source of truth for wire value -> user-facing display label,
 * for every UI surface that shows a model TYPE (ModelRegistryType:
 * llm/embedding) or UTILITY (CCModelUtility: judge/embedding) value —
 * Picker items, table cells, filter dropdown options, badges. The wire
 * value itself (API payload/query param/filter value) is never affected,
 * only what's rendered. Labels are resolved through i18next so they follow
 * the active locale; unknown values pass through unchanged.
 */
export function getModelValueLabel(value: string, t: TFunction): string {
  return t(`models.valueLabels.${value}`, { defaultValue: value });
}

export function modelTypeFilterOptions(t: TFunction): FilterOptionItem[] {
  return [
    { value: 'llm', label: getModelValueLabel('llm', t) },
    { value: 'embedding', label: getModelValueLabel('embedding', t) },
  ];
}

export function yesNoFilterOptions(t: TFunction): FilterOptionItem[] {
  return [
    { value: 'true', label: t('models.filters.yes') },
    { value: 'false', label: t('models.filters.no') },
  ];
}
